@let selectedValues = selected();

<div #list class="tw:gap-2.5" [class]="listClass()">
  @for (item of config(); track item.value) {
    <fr8bot-ui-smart-filter-chip
      [iconName]="item.icon"
      [color]="item.color"
      [selected]="selectedValues.includes(item.value)"
      (click)="onItemClick(item.value)"
    >
      {{ item.title | translate }}
    </fr8bot-ui-smart-filter-chip>
  }

  <ng-content />
</div>
